import { HttpLink } from '@apollo/client';
import { loadBrowserEnv } from '@/config';

const browserEnv = loadBrowserEnv();

export const httpLink = new HttpLink({
  uri: browserEnv.GRAPHQL_GATEWAY_API,
});
